var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "paywall-modal": true,
        "has-drawer":
          _vm.isMobile(_vm.$mq) &&
          !_vm.potentialBFECandidate &&
          _vm.hasTrialOption,
        mobile: _vm.isMobile(_vm.$mq)
      },
      attrs: { id: "top" }
    },
    [
      _c(
        "div",
        { staticClass: "close-modal-container", attrs: { id: "back-button" } },
        [
          _vm.canSkipNuxPaywall
            ? _c("div", { staticClass: "container" }, [
                !_vm.allowedtoViewEmbeddedCheckout ||
                !_vm.canShowEmbeddedCheckout
                  ? _c("div", [
                      _vm.showTieredPlans || !_vm.inTieredPlanExperiment
                        ? _c(
                            "button",
                            {
                              staticClass: "close-modal",
                              on: { click: _vm.handleClosePaywall }
                            },
                            [
                              _c("CloseButtonBlackSvg", {
                                attrs: { "data-testid": "paywall_close" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTieredPlans
                        ? _c(
                            "button",
                            {
                              staticClass: "tiered-plans-back back",
                              on: { click: _vm.goBack }
                            },
                            [
                              _c("ChevronSvg", { staticClass: "arrow" }),
                              _vm._v(" "),
                              _c("p", [_vm._v("Back")])
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _c(
                      "button",
                      { staticClass: "back", on: { click: _vm.goBack } },
                      [
                        _c("ChevronSvg", { staticClass: "arrow" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("Back")])
                      ],
                      1
                    )
              ])
            : (_vm.canShowEmbeddedCheckout || _vm.showTieredPlans) &&
              (_vm.premiumPage || _vm.inTieredPlanExperiment)
            ? _c("div", { staticClass: "container" }, [
                _c(
                  "button",
                  {
                    staticClass: "back",
                    attrs: { id: "back-button" },
                    on: { click: _vm.goBack }
                  },
                  [
                    _c("ChevronSvg", { staticClass: "arrow" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("Back")])
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.user.is_reactivating
        ? _c(
            "div",
            { staticClass: "returning-user-paywall" },
            [_c("AvailablePlans")],
            1
          )
        : _c("div", { staticClass: "new-user-paywall" }, [
            _c(
              "div",
              {
                staticClass: "one-page-header",
                class: {
                  "one-page-header": true,
                  "one-page-treatment": _vm.twoPageGroup,
                  "tiered-plans-experiment-header": _vm.inTieredPlanExperiment
                }
              },
              [
                _c(
                  "transition",
                  { attrs: { name: "side-slide", appear: "" } },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !_vm.canShowEmbeddedCheckout &&
                              !_vm.showTieredPlans,
                            expression:
                              "!canShowEmbeddedCheckout && !showTieredPlans"
                          }
                        ],
                        key: "trialTimeline"
                      },
                      [
                        _c("HowPremiumWorks", {
                          class: { "on-modal": !_vm.premiumPage },
                          attrs: {
                            nuxGoal: _vm.nux_goal,
                            interestedIn: _vm.nux_skills_needed,
                            heading: _vm.trialPaywallTextCopy.heading,
                            subHeading: _vm.trialPaywallTextCopy.subheading,
                            premiumPage: _vm.premiumPage,
                            isExperiment: _vm.isInCopyExperiment,
                            isCompact: _vm.isInCopyExperiment,
                            "trial-length": _vm.user.trial_length
                          }
                        }),
                        _vm._v(" "),
                        _vm.inTieredPlanExperiment
                          ? _c(
                              "div",
                              {
                                class: {
                                  "is-fixed": _vm.isMobile(_vm.$mq),
                                  "tiered-plans-continue-btn-container": true
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "timeline-discount-container"
                                  },
                                  [
                                    _vm.shouldShowDiscount &&
                                    _vm.inTieredPlanExperiment
                                      ? _c(
                                          "p",
                                          {
                                            class: {
                                              discount: true,
                                              "green-text": true
                                            }
                                          },
                                          [
                                            _c("LightningSvg", {
                                              staticClass: "discount-icon"
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.discountHtml
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "track",
                                        rawName: "v-track:click",
                                        value: {
                                          axId:
                                            "clicked_tiered_paywall_continue",
                                          axType: "button"
                                        },
                                        expression:
                                          "{\n                axId: 'clicked_tiered_paywall_continue',\n                axType: 'button',\n              }",
                                        arg: "click"
                                      }
                                    ],
                                    staticClass:
                                      "btn btn-green continue-btn tiered-plans-continue-btn",
                                    attrs: { id: "timeline-continue-cta" },
                                    on: { click: _vm.shouldShowTieredPlans }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Continue\n            "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _c("SubscriptionStartButton", {
                              class: { "is-fixed": !_vm.potentialBFECandidate },
                              attrs: {
                                annualPlan: _vm.annualPlan(_vm.paywall_plans),
                                id: "trialButton",
                                "trial-length": _vm.user.trial_length,
                                "show-money-back-text-copy":
                                  _vm.moneyBackTextCopyExperiment
                              },
                              on: {
                                "show-embedded-checkout":
                                  _vm.shouldShowEmbeddedCheckout
                              }
                            })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "side-slide", appear: "" } },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showTieredPlans,
                            expression: "showTieredPlans"
                          }
                        ],
                        key: "tiered-plans",
                        staticClass: "tiered-plans"
                      },
                      [
                        _c("TieredPlans", {
                          attrs: { "premium-page": _vm.premiumPage }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "side-slide", appear: "" } },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.canShowEmbeddedCheckout,
                            expression: "canShowEmbeddedCheckout"
                          }
                        ],
                        key: "embeddedCheckout"
                      },
                      [
                        _c(
                          "EmbeddedChargebeeCheckout",
                          {
                            attrs: {
                              "plan-id": _vm.firstPlan.plan_id,
                              priceWithCurrency: _vm.firstPlan.cycle_price,
                              currency: _vm.firstPlan.plan_currency,
                              "remote-id": _vm.firstPlan.plan_remote_id
                            },
                            on: {
                              "redirect-to-hosted-pages": function($event) {
                                return _vm.redirectToHostedPages()
                              },
                              "processing-payment": _vm.processPayment
                            }
                          },
                          [
                            _c("h1", [
                              _vm._v(
                                "Start your free " +
                                  _vm._s(_vm.user.trial_length) +
                                  "-day Premium trial"
                              )
                            ]),
                            _vm._v(" "),
                            _c("h2", [_vm._v("No commitment. Cancel anytime.")])
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.twoPageGroup
              ? _c(
                  "div",
                  { staticClass: "two-page-header" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "side-slide", appear: "" } },
                      [
                        !_vm.showNext &&
                        !_vm.canShowEmbeddedCheckout &&
                        !_vm.showTieredPlans
                          ? _c(
                              "div",
                              { key: "courseContents" },
                              [
                                _c("CourseContents", {
                                  attrs: { onTrialPaywall: true }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "is-fixed",
                                    attrs: { id: "continue" }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "track",
                                            rawName: "v-track:click",
                                            value: {
                                              axId:
                                                "clicked_nux_paywall_continue"
                                            },
                                            expression:
                                              "{\n                axId: 'clicked_nux_paywall_continue',\n              }",
                                            arg: "click"
                                          }
                                        ],
                                        staticClass: "btn btn-green continue",
                                        attrs: {
                                          "data-testid":
                                            "trial_paywall_two_page_continue_button"
                                        },
                                        on: { click: _vm.handleContinueClick }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Continue\n            "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showNext &&
                        !_vm.canShowEmbeddedCheckout &&
                        !_vm.showTieredPlans
                          ? _c(
                              "div",
                              { key: "trialTimeline" },
                              [
                                _c("HowPremiumWorks", {
                                  class: { "on-modal": !_vm.premiumPage },
                                  attrs: {
                                    nuxGoal: _vm.nux_goal,
                                    interestedIn: _vm.nux_skills_needed,
                                    heading: _vm.trialPaywallTextCopy.heading,
                                    subHeading:
                                      _vm.trialPaywallTextCopy.subheading,
                                    premiumPage: _vm.premiumPage,
                                    isExperiment: _vm.isInCopyExperiment,
                                    "trial-length": _vm.user.trial_length
                                  }
                                }),
                                _vm._v(" "),
                                _vm.inTieredPlanExperiment
                                  ? _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "track",
                                            rawName: "v-track:click",
                                            value: {
                                              axId:
                                                "clicked_tiered_paywall_continue",
                                              axType: "button"
                                            },
                                            expression:
                                              "{\n              axId: 'clicked_tiered_paywall_continue',\n              axType: 'button',\n            }",
                                            arg: "click"
                                          }
                                        ],
                                        staticClass:
                                          "btn btn-green continue-btn tiered-plans-continue-btn",
                                        on: { click: _vm.shouldShowTieredPlans }
                                      },
                                      [
                                        _vm._v(
                                          "\n            Continue\n          "
                                        )
                                      ]
                                    )
                                  : _c("SubscriptionStartButton", {
                                      staticClass: "is-fixed",
                                      attrs: {
                                        annualPlan: _vm.annualPlan(
                                          _vm.paywall_plans
                                        ),
                                        "trial-length": _vm.user.trial_length,
                                        "show-money-back-text-copy":
                                          _vm.moneyBackTextCopyExperiment
                                      },
                                      on: {
                                        "show-embedded-checkout":
                                          _vm.shouldShowEmbeddedCheckout
                                      }
                                    })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "side-slide", appear: "" } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showTieredPlans,
                                expression: "showTieredPlans"
                              }
                            ],
                            key: "tiered-plans",
                            staticClass: "tiered-plans"
                          },
                          [
                            _c("TieredPlans", {
                              attrs: { "premium-page": _vm.premiumPage }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("transition", {
                      attrs: { name: "side-slide", appear: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "side-slide", appear: "" } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.canShowEmbeddedCheckout,
                                expression: "canShowEmbeddedCheckout"
                              }
                            ],
                            key: "embeddedCheckout"
                          },
                          [
                            _c(
                              "EmbeddedChargebeeCheckout",
                              {
                                attrs: {
                                  "plan-id": _vm.firstPlan.plan_id,
                                  priceWithCurrency: _vm.firstPlan.cycle_price,
                                  currency: _vm.firstPlan.plan_currency,
                                  "remote-id": _vm.firstPlan.plan_remote_id
                                },
                                on: {
                                  "redirect-to-hosted-pages": function($event) {
                                    return _vm.redirectToHostedPages()
                                  },
                                  "processing-payment": _vm.processPayment
                                }
                              },
                              [
                                _c("h1", [
                                  _vm._v(
                                    "Start your free " +
                                      _vm._s(_vm.user.trial_length) +
                                      "-day Premium trial"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("h2", [
                                  _vm._v("No commitment. Cancel anytime.")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
      _vm._v(" "),
      _c("Reviews", {
        attrs: { onTrialPaywall: true, isExperiment: _vm.testimonialExperiment }
      }),
      _vm._v(" "),
      !_vm.testimonialExperiment ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _vm.onePageGroup
        ? _c(
            "div",
            [
              _c("CourseContents", { attrs: { onTrialPaywall: true } }),
              _vm._v(" "),
              _c("hr")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PaywallFeatures", { attrs: { onTrialPaywall: true } }),
      _vm._v(" "),
      _c("WhatCanILearn", { attrs: { onTrialPaywall: true } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "paywall-footer" },
        [
          !_vm.user.is_reactivating
            ? _c("HowPremiumWorks", {
                class: {
                  "on-modal": !_vm.premiumPage,
                  "two-page-footer": _vm.twoPageGroup
                },
                attrs: {
                  nuxGoal: _vm.nux_goal,
                  interestedIn: _vm.nux_skills_needed,
                  heading: "Unlock the full Brilliant experience",
                  subHeading:
                    "How a Brilliant Premium annual subscription works",
                  premiumPage: _vm.premiumPage,
                  "trial-length": _vm.user.trial_length,
                  isExperiment: _vm.isInCopyExperiment,
                  "test-id-prefix": "trial_paywall_two_pages_footer_cta"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile(_vm.$mq) && !_vm.inTieredPlanExperiment
            ? _c("SubscriptionStartButton", {
                staticClass: "footer-cta",
                class: {
                  show: _vm.showFooterButton,
                  hide: !_vm.showFooterButton
                },
                attrs: {
                  annualPlan: _vm.annualPlan(_vm.paywall_plans),
                  isFooter: true,
                  matureUsers: true,
                  "trial-length": _vm.user.trial_length,
                  "show-money-back-text-copy": _vm.moneyBackTextCopyExperiment
                },
                on: { "show-embedded-checkout": _vm.shouldShowEmbeddedCheckout }
              })
            : !_vm.isMobile(_vm.$mq) && _vm.inTieredPlanExperiment
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-green continue-btn tiered-plans-continue-btn",
                  on: { click: _vm.shouldShowTieredPlans }
                },
                [_vm._v("\n      Continue\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPaywallLoader
        ? _c(
            "div",
            { staticClass: "paywall--loader" },
            [
              _c("LoadingAnimation", {
                attrs: { size: "small", type: "spinner" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }